import { render, staticRenderFns } from "./JSelectDepart.vue?vue&type=template&id=fed3ad80&scoped=true&"
import script from "./JSelectDepart.vue?vue&type=script&lang=js&"
export * from "./JSelectDepart.vue?vue&type=script&lang=js&"
import style0 from "./JSelectDepart.vue?vue&type=style&index=0&id=fed3ad80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed3ad80",
  null
  
)

export default component.exports